@if (landlineConsumption && landlineConsumption.date) {
  <div class="text-center w-100 my-consumption-area">
    @if (selectedLandLine.billingStartDate) {
      <h2>Mes consommations DU {{ getDate(landlineConsumption, selectedLandLine, 1) }} @if (landlineConsumption.date != getDate(landlineConsumption, selectedLandLine, 2)) {
        <span [className]="environment.data.brand+'-color'">au {{ landlineConsumption.date }} </span>
      }</h2>
    }
    <div class="mb-4 procedure-card-area">
      <div [className]="'col-12'">
        <app-procedure-card [icon]="'icons/' + brand + '_consumption_voice.png'" [cursor]="false" [text]="'Appels'" [value]="landlineConsumption.total.voice.consumption.toString()"></app-procedure-card>
      </div>
    </div>
    <div class="w-100 text-left mt-2 mb-3 current-line">
      <p><strong>Forfait : </strong> <span class="offer-name">{{ selectedLandLine.offerName}} {{ displaySupportInformation ? '[ID - '+selectedLandLine.offerId+']' : '' }}</span></p>
    </div>
    <div class="total-amount-txt-area">Montant total de ma facture :
      <strong class="prixtel-color">{{ (landlineConsumption.included.price + landlineConsumption.notIncluded.price + landlineConsumption.services.price).toFixed(2).toString().replace('.', ',') }}€</strong>
      <p class="bill-amount-disclaimer">(ce montant inclut votre forfait et les éventuels services, options et communications hors-forfait)</p>
    </div>
    <button id="display-detail" type="button" class="btn-hide-detail cta_btn level_2" (click)="displayDetails()">{{ detailsButtonText }}<span></span></button>
    <app-land-line-consumption-details [landLineConsumption]="landlineConsumption" [hidden]="detailsVisibility"></app-land-line-consumption-details>
  </div>
}
